import React from "react";

import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { createMuiTheme, withStyles, makeStyles  } from '@material-ui/core/styles';
import MaterialTable from 'material-table'


import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import masterYamlLogo from "assets/img/apps/masteryaml.jpg";
import syndieLogo from "assets/img/apps/1.png";
import douanneLogo from "assets/img/apps/2.png";
import coinLogo from "assets/img/apps/3.png";
import kfwLogo from "assets/img/apps/4.png";
import sdcLogo from "assets/img/apps/5.png";
import dronesLogo from "assets/img/apps/6.png";
import kyclogo from "assets/img/apps/7.png";
import dmslogo from "assets/img/apps/8.jpg"
import luxorlogo from "assets/img/apps/9.png";
import airbuslogo from "assets/img/apps/10.png";
import tracieLogo from "assets/img/apps/11.png"
import FullScreenDialog from "components/Dialog/FullScreenDialog.js";
import Syndie from 'views/Syndie/Syndie';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import Tooltip from '@material-ui/core/Tooltip';

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import KFW from "views/KFW/KFW";
import Customs from "views/Customs/Customs";
import Digicoin from "views/DigiCoin/DigiCoin";
import SDC from "views/SDC/SDC";
import Drones from "views/Drones/Drones";
import KYC from "views/KYC/KYC";
import DMS from "views/DMS/DMS";
import Luxor from "views/Luxor/Luxor";
import Airbus from "views/Airbus/Airbus";
import Traci2 from "views/Traci2/Traci2";
import MasterForm from "views/MasterForm/MasterForm";

import { useGlobal } from 'reactn';
import { FUNCTION_URL } from 'constants.js';

import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: "lightgray",
  },
}))(MuiDialogContent);

export default function Dashboard() {
  const history = useHistory();
  const classes = useStyles();
  const [user] = useGlobal('user')
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [eventHub, setEventHub] = useGlobal('eventHub')
  const [open, setOpen] = React.useState(false);
  const [openMasterForm, setOpenMasterForm] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [appList, setAppList] = React.useState([]);
  const [detail, setDetail] = React.useState("syndie");
  const [progressOn, setprogressOn] = React.useState(false);
  const [progressMessage, setProgressMessage] = React.useState("Getting Application List");
  const [application, setApplication] = React.useState({});
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [selectedTimeFrom, setSelectedTimeFrom] = React.useState(new Date());
  const [selectedTimeTo, setSelectedTimeTo] = React.useState(new Date());
  const [canReserve, setCanReserve] = React.useState(false);
  const [tempApp, setTempApp] = React.useState();
  const [columns, setColumns] = React.useState([
    { title: 'Name', field: 'user' },
    { title: 'Email', field: 'email' },
    { title: 'Date', field: 'date' },
    { title: 'Time Slot', field: 'slot' }
  ]);
  const [data, setData] = React.useState([]);

  const handleClose = (value) => {
    getStatusForAll();
    setOpen(false);
    setOpenMasterForm(false)
  };

  React.useEffect(() => {
    setprogressOn(true)
    whiteLogin();
  }, [])

  const getStatusForAll = () => {
    fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        'Access-Control-Allow-Credentials': 'true'
      },
      body: JSON.stringify({
        "name": "Azure",
        "user": user,
        "operation": "status"
      })
    })
      .then(data => { return data.json() })
      .then(jsondata => {
        setAppList(jsondata);
        setprogressOn(false);
      });
  }

  const whiteLogin = () => {

    fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'true'
      },
      body: JSON.stringify({
        "operation": "login",
        "user": user
      })
    }).then(data => { return data.json() })
      .then(jsondata => {
        if (jsondata.success) {
          getStatusForAll();
          setEventHub(jsondata.eventHub);
          setCanReserve(jsondata.can_reserve)
          setIsAdmin(jsondata.isAdmin)
        } else {
          history.push("/user/unauth");
        }
      });

  }

  const renderDetail = () => {
    return <div>
      {detail === "blvd-syndie" &&
        <Syndie app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-kfw" &&
        <KFW app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-customs" &&
        <Customs app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-digicoin" &&
        <Digicoin app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-sdc" &&
        <SDC app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-drones" &&
        <Drones app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-kyc" &&
        <KYC app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-docmgmt" &&
        <DMS app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-luxor" &&
        <Luxor app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-airbus" &&
        <Airbus app={application} isAdmin={isAdmin} />
      }
      {detail === "blvd-tracie" &&
        <Traci2 app={application} isAdmin={isAdmin} />
      }
    </div>
  }

  const renderMasterForm = () => {
    return (
      <div>
        <MasterForm />
      </div>
    )
  }

  const getLogo = (appId) => {
    if (appId === 1) {
      return syndieLogo
    } else if (appId === 2) {
      return douanneLogo
    } else if (appId === 3) {
      return coinLogo
    } else if (appId === 4) {
      return kfwLogo
    } else if (appId === 5) {
      return sdcLogo
    } else if (appId === 6) {
      return dronesLogo
    } else if (appId === 7) {
      return kyclogo
    } else if (appId === 8) {
      return dmslogo
    } else if (appId === 9) {
      return luxorlogo
    } else if (appId === 10) {
      return airbuslogo
    } else if (appId === 11) {
      return tracieLogo
    } else {
      return douanneLogo
    }
  }

  const action = (action, app) => {

    if (action === "start") {
      setProgressMessage("Starting Application...This can take a while");
    }
    else {
      setProgressMessage("Stopping Application...This can take a while");
    }
    setprogressOn(true)

    fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        'Access-Control-Allow-Credentials': 'true'
      },
      body: JSON.stringify({
        "user": "Azure",
        "user": user,
        "operation": action,
        "app": app
      })
    }).then(data => { return data.json() })
      .then(response => {
        if (action === "start") {
          openAppPage(app)
        }
        getStatusForAll();

      })

    if (action === "start") {
      setTimeout(function () {
        app["appStatus"] = 1
        openAppPage(app)
        getStatusForAll();
      }, 25000);
    }
  }

  const getStatus = (value) => {
    if (value == 0) {
      return "Stopped"
    } else if (value === 1) {
      return "Deployment in Progress"
    } else {
      return "Running"
    }
  }

  function checkAppReservations(app, func) {
    getReservations(app).then((data) => {
      var count = 0
      var reservation = []
      data.map((res) => {
        var date = new Date()
        if (res.from <= date.toISOString() && res.to >= date.toISOString()) {
          count = 1
          reservation = res
        }
      })
      if(count == 1 && (reservation.email != user.email)) {
        alert("Machine reserved by " + reservation.user + ", between: " + reservation.slot)
      } else {
        if (func == "openAppPage") {
          openAppPage(app)
        } else {
          action(func, app)
        }
      }
    })
  }

  var openAppPage = (app) => {
    setprogressOn(true);
    setProgressMessage("Fetching current status of " + app.appTitle)
    fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        'Access-Control-Allow-Credentials': 'true'
      },
      body: JSON.stringify({
        "app": app,
        "user": user,
        "operation": "appStatus"
      })
    })
      .then(data => { return data.json() })
      .then(jsondata => {
        if(app.appStatus == 1){
          jsondata["appStatus"] = 1
        }
        setApplication(jsondata)
        setprogressOn(false);
        setDetail(app.vmId);
        setOpen(true);
      });
  }

  const addReservation = () => {
    var modifieddate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), selectedTimeFrom.getHours(), selectedTimeFrom.getMinutes(), 0);
    fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        'Access-Control-Allow-Credentials': 'true'
      },
      body: JSON.stringify({
        "app": tempApp,
        "user": user,
        "date": modifieddate,
        "from": modifieddate,
        "to": new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), selectedTimeTo.getHours(), selectedTimeTo.getMinutes(), 0),
        "timeFrom": selectedTimeFrom.getHours() + ':' + (selectedTimeFrom.getMinutes().toString().length > 1 ? selectedTimeFrom.getMinutes() : '0' + selectedTimeFrom.getMinutes()),
        "timeTo": selectedTimeTo.getHours() + ':' + (selectedTimeTo.getMinutes().toString().length > 1 ? selectedTimeTo.getMinutes() : '0' + selectedTimeTo.getMinutes()),
        "operation": "addReservation"
      })
    })
      .then(data => { return data.json() })
      .then(jsondata => {
        getReservations(tempApp)
      });
  }

  async function getReservations(app) {
    setData([])
    var reservations = []
    await fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        'Access-Control-Allow-Credentials': 'true'
      },
      body: JSON.stringify({
        "app": app,
        "user": user,
        "operation": "getReservations"
      })
    })
      .then(data => { return data.json() })
      .then(jsondata => {
        reservations = jsondata
        jsondata.map(data => {
          var date = new Date(data['date'])
          data['date'] = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        })
        setData(jsondata)
      });
    return reservations;
  }

  const deleteReservation = (data) => {
    fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',

        'Access-Control-Allow-Credentials': 'true'
      },
      body: JSON.stringify({
        "app": tempApp,
        "resdata": data,
        "user": user,
        "operation": "deleteReservation"
      })
    })
      .then(data => { return data.json() })
      .then(jsondata => {
        getReservations(tempApp)
      });
  }

  const body = (
    <div>
      <p>
        Select date and time slot to book your machine.
      </p>
      <div style={{marginBottom: 10}}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container justify="space-around" spacing={4}>
            <Grid item xs={3}>
              <KeyboardDatePicker
                margin="none"
                id="date-picker"
                label="Select Date"
                format="dd/MM/yyyy"
                value={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                minDate={new Date()}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <KeyboardTimePicker
                margin="none"
                id="time-picker"
                label="From"
                value={selectedTimeFrom}
                onChange={(time) => setSelectedTimeFrom(time)}
                KeyboardButtonProps={{
                  'aria-label': 'change time',
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <KeyboardTimePicker
                margin="none"
                id="time-picker"
                label="To"
                value={selectedTimeTo}
                onChange={(time) => setSelectedTimeTo(time)}
                KeyboardButtonProps={{
                  'aria-label': 'change time',
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <button type="button" onClick={() => addReservation()} style={{ height: 30, backgroundColor: 'green', color: 'white', borderRadius: 5 }}>
                    Reserve
              </button>
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
      </div>
      <div className={classes.table}>
        <MaterialTable
          options={{
            search: false,
            pageSize: 4,
            pageSizeOptions: [4],
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: '#253747',
              color: 'white'
            },
            rowStyle: {
              fontSize: 14,
            },
          }}
          localization={{
            header: {
              actions: 'Delete'
            }
          }}
          editable={{
            isDeletable: rowData => rowData.email === user.email,
            onRowDelete: oldData =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  deleteReservation(oldData)
                  resolve()
                }, 1000)
              }),
          }}
          columns={columns}
          data={data}
          title="Reservations"
        />
      </div>
    </div>
  );

  return (
    <div>
      <GridContainer>
        {appList.map((app, index) => (
          <GridItem xs={12} sm={12} md={3} key={index}>
            <Card style={{ backgroundColor: "#253747", color: "white" }}>

              {app.vmRunning ?
                <CardHeader color="danger" style={{ height: "25%" }}>
                  <img src={getLogo(app.appId)} alt="logo" style={{ width: "100%", cursor: "pointer" }} onClick={() => { checkAppReservations(app, "openAppPage") }} />
                </CardHeader>
                :
                <CardHeader color="success" style={{ height: "25%" }}>
                  <img src={getLogo(app.appId)} alt="logo" style={{ width: "100%", cursor: "pointer" }} onClick={() => { checkAppReservations(app, "openAppPage") }} />
                </CardHeader>
              }


              <CardBody>
                <h4 style={{ cursor: "pointer" }} onClick={() => { checkAppReservations(app, "openAppPage") }}>{app.appTitle}</h4>
              </CardBody>
              <CardFooter chart>
                <div >
                  Status : {getStatus(app.appStatus)}
                </div>

                <Tooltip title='Reserve Machine' style={{ marginLeft: '30%' }}>
                  <IconButton
                    disabled={!canReserve}
                    edge="end"
                    color="inherit"
                    aria-label="Reserve"
                    onClick={() => {
                      setModal(true)
                      setSelectedDate(new Date())
                      setTempApp(app)
                      getReservations(app)
                    }}>
                    <AccessTimeOutlinedIcon color={canReserve ? "secondary" : "disabled"} />
                  </IconButton>
                </Tooltip>

                {app.vmRunning ?
                  <i className="fa fa-stop fa-2x" style={{ cursor: "pointer", color: "#e53935" }} onClick={() => { checkAppReservations(app, "stop") }} aria-hidden="true"></i>
                  :
                  <i className="fa fa-play fa-2x" style={{ cursor: "pointer", color: "green" }} onClick={() => { checkAppReservations(app, "start") }} aria-hidden="true"></i>
                }

              </CardFooter>
            </Card>
          </GridItem>
        ))}
        {isAdmin ?
          <GridItem xs={12} sm={12} md={3} key={"genMaster"}>
            <Card style={{ backgroundColor: "#253747", color: "white", cursor: "pointer" }} onClick={() => setOpenMasterForm(true)}>
              <CardHeader color="success" style={{ height: "25%" }}>
                <img src={masterYamlLogo} alt="logo" style={{ width: "100%", height: 110 }} />
              </CardHeader>
              <CardBody>
                <h4>Generate Master.yaml</h4>
              </CardBody>
            </Card>
          </GridItem>
          : null}
      </GridContainer>

      <Dialog 
        maxWidth={'md'}
        onClose={() => {
          setModal(false)
          setSelectedDate(new Date())
          setSelectedTimeFrom(new Date())
          setSelectedTimeTo(new Date())
        }} 
        aria-labelledby="customized-dialog-title" 
        open={modal}
      >
        <DialogTitle 
          id="customized-dialog-title" 
          onClose={() => {
            setModal(false)
            setSelectedDate(new Date())
            setSelectedTimeFrom(new Date())
            setSelectedTimeTo(new Date())
          }} 
        >
         {tempApp?.appTitle}
        </DialogTitle>
        <DialogContent>
          {body}
        </DialogContent>
      </Dialog>

      <Backdrop style={{ zIndex: 999, color: '#fff', textAlign: "center" }} open={progressOn}>
        <GridContainer>
          <GridItem key="one" xs={12} sm={12} md={12}>
            <CircularProgress color="inherit" />
          </GridItem>
          <GridItem key="two" xs={12} sm={12} md={12}>
            {progressMessage}
          </GridItem>
        </GridContainer>
      </Backdrop>

      <FullScreenDialog
        open={open}
        onClose={handleClose}
        title={application.appTitle}
        dialogContent={renderDetail()}
      />

      <FullScreenDialog
        open={openMasterForm}
        onClose={handleClose}
        title={'Generate Master.yaml'}
        dialogContent={renderMasterForm()}
      />
    </div>
  );
}